/**
 * beginMpLiveMatch — P6-14 apply match_start to live map + local loadout.
 */

export function pickLocalMatchLoadout({ match, localClientId, fallback } = {}) {
  const me = (match?.players || []).find((p) => p.clientId === localClientId);
  const championId = me?.championId || fallback?.championId;
  const spell1 = me?.spell1 || fallback?.spells?.[0];
  const spell2 = me?.spell2 || fallback?.spells?.[1];
  return {
    championId,
    mapId: match?.mapId || fallback?.mapId,
    spells: [spell1, spell2].filter(Boolean),
    runePage: me?.runePage || fallback?.runePage,
    masteryPage: me?.masteryPage || fallback?.masteryPage
  };
}

/**
 * @param {{
 *   match: object,
 *   localClientId: string,
 *   hideOverlays: () => void,
 *   switchChampion: (id: string) => void,
 *   loadLiveMap: (id: string) => void,
 *   applyLobbySpells: (cfg: object) => void,
 *   applyLobbyRunes: (cfg: object, entity: object, inv: object) => void,
 *   applyLobbyMasteries: (cfg: object, entity: object) => void,
 *   playerEntity: object,
 *   playerInventory: object,
 *   fallback?: object
 * }} opts
 */
export function beginMpLiveMatch(opts) {
  const {
    match,
    localClientId,
    hideOverlays,
    switchChampion,
    loadLiveMap,
    applyLobbySpells,
    applyLobbyRunes,
    applyLobbyMasteries,
    playerEntity,
    playerInventory,
    fallback
  } = opts;
  if (typeof hideOverlays === 'function') hideOverlays();
  const cfg = pickLocalMatchLoadout({ match, localClientId, fallback });
  if (cfg.championId && typeof switchChampion === 'function') {
    switchChampion(cfg.championId);
  }
  if (cfg.mapId && typeof loadLiveMap === 'function') {
    loadLiveMap(cfg.mapId);
  }
  if (typeof applyLobbySpells === 'function') applyLobbySpells(cfg);
  if (typeof applyLobbyRunes === 'function') {
    applyLobbyRunes(cfg, playerEntity, playerInventory);
  }
  if (typeof applyLobbyMasteries === 'function') {
    applyLobbyMasteries(cfg, playerEntity);
  }
  return cfg;
}

export function hideMatchBrowserOverlays(doc = document) {
  const mb = doc.getElementById('match-browser-overlay');
  if (mb) {
    mb.hidden = true;
    mb.style.display = 'none';
  }
  const lobby = doc.getElementById('lobby-overlay');
  if (lobby) {
    lobby.hidden = true;
    lobby.style.display = 'none';
  }
}
